import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { fetchEvents } from "../api";
import { notFinishedClause } from "../utils/searchFilters";
import { CONTACT_EMAIL, AUTHOR_EMAIL, PORTFOLIO_URL, DATA_SOURCE_URL } from "../global";
import "./Purpose.css";

function Purpose() {
  const [count, setCount] = useState(null);

  // Le chiffre affiché vient du jeu de données lui-même, pour ne pas vieillir.
  useEffect(() => {
    const ac = new AbortController();
    fetchEvents({ limit: 1, where: notFinishedClause() }, ac.signal)
      .then((result) => setCount(result.total_count ?? null))
      .catch(() => {
        // Décoratif : en cas d'échec, la phrase reste correcte sans chiffre.
      });
    return () => ac.abort();
  }, []);

  return (
    <div className="container">
      <PageHeader
        eyebrow="À propos"
        title="Un agenda, une signature"
        intro="Getout Paname rassemble la programmation culturelle parisienne au même endroit, et la rend agréable à parcourir."
      />

      <div className="pa-prose pa-about__prose">
        <h2>Ce que vous trouvez ici</h2>
        <p>
          {count
            ? `${count.toLocaleString("fr-FR")} événements actuellement à l'affiche`
            : "Tous les événements actuellement à l'affiche"}{" "}
          à Paris&nbsp;: concerts, expositions, théâtre, danse, ateliers,
          balades urbaines, rendez-vous pour les enfants. Vous pouvez filtrer
          par période, par type, par tarif, et ne garder que les événements
          accessibles aux personnes en situation de handicap.
        </p>
        <p>
          Les favoris vous permettent de mettre des sorties de côté. Ils restent
          dans votre navigateur&nbsp;: ni compte, ni inscription.
        </p>

        <h2>D'où viennent les données</h2>
        <p>
          Tout provient du jeu de données ouvert{" "}
          <a href={DATA_SOURCE_URL} target="_blank" rel="noopener noreferrer">
            «&nbsp;Que faire à Paris&nbsp;?&nbsp;»
          </a>
          , publié par la Direction de la Communication de la Ville de Paris et
          mis à jour chaque jour. Getout Paname n'ajoute aucun contenu
          éditorial&nbsp;: il reprend les fiches telles qu'elles sont publiées,
          et se contente de les rendre faciles à trouver.
        </p>

        <h2>Ce que Getout Paname n'est pas</h2>
        <ul>
          <li>
            <strong>Pas un service de la Ville de Paris.</strong> C'est un site
            indépendant, qui s'appuie sur ses données ouvertes sans lui être
            affilié.
          </li>
          <li>
            <strong>Pas une billetterie.</strong> Aucun billet n'est vendu ici.
            La réservation se fait toujours chez l'organisateur, dont le lien
            figure sur chaque fiche.
          </li>
          <li>
            <strong>Pas un réseau social.</strong> Aucun compte, aucun cookie,
            aucun traqueur, aucune publicité.
          </li>
        </ul>

        <h2>Une erreur dans une fiche&nbsp;?</h2>
        <p>
          Un horaire faux, un tarif périmé, un événement qui n'a plus lieu&nbsp;?
          Signalez-le à <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          Comme l'information vient de la Ville de Paris, la corriger
          durablement suppose aussi de le lui signaler, mais prévenez-nous, cela
          évitera à d'autres de se déplacer pour rien.
        </p>

        <h2>Qui est derrière</h2>
        <p>
          Getout Paname est conçu et maintenu par Yanis Arenes, en solo. Vous
          pouvez découvrir ses autres projets sur{" "}
          <a href={PORTFOLIO_URL} target="_blank" rel="noopener noreferrer">
            sinaysenera.dev
          </a>{" "}
          ou lui écrire directement à{" "}
          <a href={`mailto:${AUTHOR_EMAIL}`}>{AUTHOR_EMAIL}</a>.
        </p>
      </div>

      <nav className="pa-about__legal" aria-label="Informations légales">
        <Link to="/mentions-legales" className="pa-link">
          Mentions légales
        </Link>
        <Link to="/confidentialite" className="pa-link">
          Politique de confidentialité
        </Link>
      </nav>
    </div>
  );
}

export default Purpose;
